import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { EventDataContext } from "./EventDataContext";
import { Send } from "lucide-react";

const TemplateAccordion = ({ brandingColours, sender }) => {
  const [chatData, setChatData] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [clientReply, setClientReply] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { EventData } = useContext(EventDataContext);
  const eventId = EventData?._id;

  const fetchChatData = async () => {
    if (!eventId) return;
    setLoading(true);
    setError("");

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/templateChat/${eventId}`,
        { withCredentials: true }
      );
      setChatData(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      console.error("Error fetching chat data:", err);
      setError("Failed to load chat.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChatData();
  }, [eventId]);

  const handleToggle = (index, field) => {
    setExpanded((prev) => ({
      ...prev,
      [`${index}_${field}`]: !prev[`${index}_${field}`],
    }));
  };

  const handleSendReply = async () => {
    if (!clientReply.trim()) return;

    const newMessage = {
      sender: sender,
      text: clientReply.trim(),
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/${sender}/templateChat`,
        {
          eventId,
          newMessage,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setClientReply("");
      alert("Reply sent successfully!");
      fetchChatData(); 
    } catch (err) {
      console.error("Error saving reply:", err);
      alert("Failed to save reply.");
    }
  };

  const formatDate = (date) => {
    const newDate = new Date(date);
    const day = newDate.getDate().toString().padStart(2, "0");
    const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
    const year = newDate.getFullYear();
    let hours = newDate.getHours();
    const minutes = newDate.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedTime = `${hours}:${minutes} ${ampm}`;
    
    return `${day}/${month}/${year} ${formattedTime}`;
  };

  if (loading) return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loading chat...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red", marginTop: "2rem" }}>{error}</p>;

  return (
    <div style={{ maxWidth: "700px", margin: "2rem auto" }}>
      {Array.isArray(chatData) && chatData.length > 0 ? (
        chatData.map((chat, index) => (
          <div
            key={chat._id || index}
            style={{
              border: "1px solid #e5e7eb",
              marginBottom: "16px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
                background:
                  chat.sender === "client"
                    ? "linear-gradient(to right, #1C1154, #260F99)"
                    : "#f3f4f6",
              }}
            >
              <button
                onClick={() => handleToggle(index, chat.sender)}
                style={{
                  width: "70%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "16px",
                  background: "transparent",
                  color:
                    chat.sender === "client"
                      ? brandingColours?.secondaryColor || "#ffffff"
                      : "#000000",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {chat.sender === "client" ? "Client Edit" : "Feedback"}
              </button>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  marginLeft: "8px",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  color:
                    chat.sender === "client"
                      ? "#ffffff"
                      : "#000000",
                }}
              >
                {formatDate(chat.timestamp)}
              </span>
            </div>
            {expanded[`${index}_${chat.sender}`] && (
              <div
                style={{
                  padding: "16px",
                  backgroundColor: "transparent",
                  color: "#374151",
                  whiteSpace: "pre-line",
                }}
              >
                {chat.text || "No content"}
              </div>
            )}
          </div>
        ))
      ) : (
        <p style={{ textAlign: "center", color: "#6b7280" }}>
          No chat data found.
        </p>
      )}

      <div style={{ marginTop: "32px", paddingTop: "16px", borderTop: "1px solid #e5e7eb" , paddingLeft: '15px'}}>
        <h2 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px"}}>
          {sender === "client" ? "Reply to Edits" : "Reply to Client"}
        </h2>
        <textarea
          placeholder="Enter Reply..."
          value={clientReply}
          onChange={(e) => setClientReply(e.target.value)}
          rows={3}
          style={{
            width: "100%",
            padding: "12px",
            paddingLeft: "0px",
            fontSize: "14px",
            border: "none",
            resize: "vertical",
            marginBottom: "12px",
            fontFamily: "inherit",
          }}
        />
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={handleSendReply}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 16px",
              backgroundColor: brandingColours?.primaryColor || "#1C1154",
              color: brandingColours?.secondaryColor || "#ffffff",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "500",
              fontSize: "14px",
            }}
          >
            <Send size={18} />
            Send Reply
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateAccordion;
